import React from "react";
import PdfViewer from "../../PdfViewer";

const PolizaEficasia2025 = () => {
  const pdfUrl = `${process.env.REACT_APP_BUCKET}/pdf/polizas/251118-Poliza-de-Servicios-X440-G2-48P.pdf`;
  /*const pdfUrl = "/pdf/251118-Poliza-de-Servicios-X440-G2-48P.pdf";*/

  console.log("PDF URL:", pdfUrl);

  return (
    <>
      <main>
        <div class="titulo">
          <h1>Póliza 2025</h1>
        </div>
        <div className="pdf-container">
          <PdfViewer pdfUrl={pdfUrl} />
        </div>
      </main>
    </>
  );
};

 export default PolizaEficasia2025;
